import type { CommitteeApprovalRole } from '../services/ApplicationService';

export type CommitteeApprovalNextStepInput = {
  hasNext: boolean;
  pendingRoles: CommitteeApprovalRole[];
  nextRoles: CommitteeApprovalRole[];
};

export function joinRoleLabelsWithY(labels: string[]): string {
  if (labels.length === 0) return '';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} y ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')} y ${labels[labels.length - 1]}`;
}

/**
 * Copy del modal de aprobación LEGACY (#52834 T6).
 * Deriva de GET /committee/approve: roles[] pendientes del nivel, nextRole, hasNext.
 */
export function buildCommitteeApprovalNextStepCopy(
  input: CommitteeApprovalNextStepInput,
): string | null {
  if (!input.hasNext) {
    return 'Una vez confirmada, se completará el circuito y la carpeta será cerrada.';
  }
  if (input.pendingRoles.length >= 2) {
    const labels = input.pendingRoles.map((role) => role.label).filter(Boolean);
    if (labels.length === 0) return null;
    return `Este nivel requiere la aprobación de ${joinRoleLabelsWithY(labels)}. Tu confirmación no cierra el nivel hasta que ambos aprueben.`;
  }
  const nextLabels = input.nextRoles.map((role) => role.label).filter(Boolean);
  if (nextLabels.length === 0) return null;
  return `Una vez confirmada, la solicitud será enviada a ${joinRoleLabelsWithY(nextLabels)} para su revisión.`;
}
